import { useQuery } from '@apollo/client';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { NotFound } from '~/components/common/NotFound';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { useRouteParam } from '~/hooks/routing';

const OUTCROP_VIDEOS_PAGE = graphql(`
  query OutcropVideosPage($id: ID!) {
    outcropGet(id: $id) {
      id
      videos {
        id
        name
        url
      }
    }
  }
`);

export default function OutcropVideosPage() {
  return (
    <ApolloProviderV4>
      <OutcropVideosPageInner />
    </ApolloProviderV4>
  );
}

function OutcropVideosPageInner() {
  const outcropId = useRouteParam('outcropId', parseInt);
  const { data, loading } = useQuery(OUTCROP_VIDEOS_PAGE, {
    variables: {
      id: outcropId,
    },
  });

  const outcrop = data?.outcropGet;
  const videos = outcrop?.videos ?? [];

  if (loading) return <SpinnerPlaceholder />;
  if (!outcrop) return <NotFound />;

  return (
    <div className="grid lg:grid-cols-2 gap-6">
      {videos.map(v => (
        <div key={v.id} className="w-full aspect-square thumbnail">
          <iframe title={v.name} src={v.url} className="w-full h-full" />
          <div className="caption text-center">{v.name}</div>
        </div>
      ))}
    </div>
  );
}
